import Options from "./ExpenseFilterOptions";
import LlSelect from '@/components/LlSelect.vue';
export default {
  name: "ExpenseFilter",
  components: {
    LlSelect
  },
  props: {
    userService: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        billedState: "wip",
        customFlag: undefined,
        expenseType: undefined,
        attachments: "all"
      },
      options: Options,
      me: undefined,
      showType: undefined,
      users: []
    };
  },
  emits: ["filter"],
  async mounted() {
    const [me, users] = await Promise.all([this.userService.getMe(), this.userService.list()]);
    this.me = me;
    this.users = users.map(user => ({
      label: user.name,
      value: user.id
    }));
    if (!this.me.permissions.time.createOthers) {
      this.form.user = this.users.find(u => u.id === this.me.id);
    }
    this.showType = this.me.company.settings.expenses?.sync;
    if (this.me?.company.settings?.labels?.customFlag) {
      this.form.customFlag = "any";
    }
    if (this.showType) {
      this.form.expenseType = "All";
    }
    this.emitChange();
  },
  methods: {
    emitChange() {
      this.$nextTick(() => {
        this.$emit("filter", this.form);
      });
    }
  }
};